// extracted by mini-css-extract-plugin
export default {"inputGroup":"Input_inputGroup__vQeZj"};